export const modal = {
  modifyTitle: "EDIT RESERVATION",
  createTitle: "CREATE RESERVATION",
  modifyAction: "Edit reservation",
  createAction: "Create reservation",
  processing: "Processing reservation...",

  selectRoomType: "Select room type",
  selectAccommodation: "Select an accommodation",

  quantity: "Quantity",
  arrival: "Arrival",
  departure: "Departure",
  guestName: "Guest name",
  email: "Email",
  phone: "Phone",
  guestsNumber: "Number of guests",
  price: "Price",
  cancel: "Cancel",

  noTemplateSummary: "No active template",
  noTemplateDetail: "No template available",

  limitReachedSummary: "Limit reached",
  limitPromotionDetail: "You can’t add more than 1 promotion",
  limitTaxDetail: "You can’t add more than 1 tax",

  validations: {
    fillRequired: "Please complete all required fields.",
    phoneMin: "The phone number must have at least 5 digits.",
    selectDates: "Please select arrival and departure dates.",
    guestsMin: "Number of guests must be at least 1.",
    priceNegative: "Price cannot be negative.",
  },
};

export default modal;
